var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 3.125H2.34375C2.25781 3.125 2.1875 3.19531 2.1875 3.28125V4.53125C2.1875 4.61719 2.25781 4.6875 2.34375 4.6875H17.6562C17.7422 4.6875 17.8125 4.61719 17.8125 4.53125V3.28125C17.8125 3.19531 17.7422 3.125 17.6562 3.125ZM17.6562 15.3125H2.34375C2.25781 15.3125 2.1875 15.3828 2.1875 15.4688V16.7188C2.1875 16.8047 2.25781 16.875 2.34375 16.875H17.6562C17.7422 16.875 17.8125 16.8047 17.8125 16.7188V15.4688C17.8125 15.3828 17.7422 15.3125 17.6562 15.3125ZM17.6562 9.21875H2.34375C2.25781 9.21875 2.1875 9.28906 2.1875 9.375V10.625C2.1875 10.7109 2.25781 10.7812 2.34375 10.7812H17.6562C17.7422 10.7812 17.8125 10.7109 17.8125 10.625V9.375C17.8125 9.28906 17.7422 9.21875 17.6562 9.21875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDouble);
export default __webpack_public_path__ + "static/media/arrow-left-double.4bd9c792f195840856b4960eba469dcc.svg";
export { ForwardRef as ReactComponent };